import { useDispatch } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';
import { useOktaAuth } from '@okta/okta-react';
import { enqueueSnackbar } from '../../../../../../actions/notificationAction';
import { t13s } from '../../../../../../translationKeys/index';
import addOrderCommentService from '../services/addOrderComment';
import { fetchCountOrderComments } from '../../../../../../actions/orderActions';
import { CommentDataToCreate, FlagType } from '../../interfaces';

interface Variables {
  operationId: number;
  commentDataToCreate: CommentDataToCreate;
  flagType: FlagType;
}

const useAddOrderComment = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { authState } = useOktaAuth();

  const {
    isLoading,
    isError,
    isSuccess,
    data,
    error,
    mutate: addOrderComment,
  } = useMutation(
    ({ operationId, commentDataToCreate }: Variables) =>
      addOrderCommentService(operationId, commentDataToCreate),
    {
      onSuccess: (_successData, variables) => {
        queryClient.invalidateQueries('fetchOrderComments', { exact: false });
        if (variables.flagType === 'operationDetail') {
          dispatch(
            fetchCountOrderComments(
              variables?.operationId,
              authState?.idToken?.claims?.email
            )
          );
        }

        if (variables.flagType === 'operationList') {
          queryClient.invalidateQueries('getOperations', { exact: false });
        }
        dispatch(
          enqueueSnackbar(t13s.NOTIFICATION.ORDER_COMMENT_CREATED, {
            variant: 'success',
          })
        );
      },
      onError: () => {
        dispatch(
          enqueueSnackbar(t13s.NOTIFICATION.CREATE_ORDER_COMMENT_FAILURE, {
            variant: 'error',
          })
        );
      },
    }
  );

  return {
    isLoading,
    isError,
    data,
    error,
    isSuccess,
    addOrderComment,
  };
};

export default useAddOrderComment;
